/* Word-boundary truncation for homepage reel captions.

   The rail seeds short curated captions, but when the Instagram app-proxy
   feed answers it replaces the cards with real IG captions, which are
   long-form marketing copy. CSS -webkit-line-clamp then cuts mid-word
   ("...designed around YOU. That'").

   This trims each caption to the last whole word inside a budget and
   appends a single ellipsis. A MutationObserver re-runs it because the
   live feed calls track.replaceChildren() after this script has run. */
(function () {
  var LIMIT = 96;
  var MIN_KEEP = 40;

  function tidy(node) {
    if (!node || node.dataset.rxTidied === 'true') return;
    var text = (node.textContent || '').replace(/\s+/g, ' ').trim();
    if (!text) return;

    if (text.length > LIMIT) {
      var cut = text.slice(0, LIMIT);
      var lastSpace = cut.lastIndexOf(' ');
      if (lastSpace > MIN_KEEP) cut = cut.slice(0, lastSpace);
      text = cut.replace(/[\s.,;:!?\u2014-]+$/, '') + '\u2026';
    }

    node.textContent = text;
    node.dataset.rxTidied = 'true';
  }

  function run(root) {
    var scope = root || document;
    var captions = scope.querySelectorAll('.rxfh-instagram__caption');
    for (var i = 0; i < captions.length; i++) tidy(captions[i]);
  }

  function watch() {
    var tracks = document.querySelectorAll('.rxfh-instagram__track');
    for (var i = 0; i < tracks.length; i++) {
      var track = tracks[i];
      if (track.dataset.rxWatched === 'true') continue;
      track.dataset.rxWatched = 'true';
      run(track);
      if (window.MutationObserver) {
        (function (scoped) {
          new MutationObserver(function () { run(scoped); })
            .observe(scoped, { childList: true });
        })(track);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch, { once: true });
  } else {
    watch();
  }

  document.addEventListener('shopify:section:load', watch);
})();
